import { useEffect } from "react";
import { AnimatePresence, easeInOut, motion } from "framer-motion";
import { Image } from "react-bootstrap";
import { EthWallets } from "../wallets/EthWallets";
import "./WalletAsidebar.scss";

function WalletAsidebar({ showWalletSidebar, handleWalletSidebar }) {
  const handleClose = () => handleWalletSidebar();

  useEffect(() => {
    if (showWalletSidebar) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "auto";
    }
  }, [showWalletSidebar]);

  return (
    <AnimatePresence>
      {showWalletSidebar && (
        <motion.div
          initial={{ x: "100%", opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: "100%", opacity: 0 }}
          transition={{ duration: 0.3, ease: easeInOut }}
          className="connect-offcanvas"
        >
          <div className="offsetWrapper">
            <button className="close" onClick={handleClose}>
              <Image src={process.env.REACT_APP_S3_IMAGE_PATH + 'closeArrow.svg'} />
            </button>

            <div className="content">
              <div className="text-holder">
                <h3>Connect Your Wallet</h3>
                <p>
                  If you don’t have a wallet yet, you can select a provider and
                  create one now.
                </p>
              </div>

              <EthWallets handleClose={handleClose} />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default WalletAsidebar;
